/**
 * @generated SignedSource<<64745fcd968c0fa968dd61507a551224>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type RepositoryLabelIndexPageContentInternal$data = {
  readonly " $fragmentSpreads": FragmentRefs<"RepositoryLabelsInternal">;
  readonly " $fragmentType": "RepositoryLabelIndexPageContentInternal";
};
export type RepositoryLabelIndexPageContentInternal$key = {
  readonly " $data"?: RepositoryLabelIndexPageContentInternal$data;
  readonly " $fragmentSpreads": FragmentRefs<"RepositoryLabelIndexPageContentInternal">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RepositoryLabelIndexPageContentInternal",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "RepositoryLabelsInternal"
    }
  ],
  "type": "Repository",
  "abstractKey": null
};

(node as any).hash = "85104ef0e95f2a062c4eb5827493612d";

export default node;
